import ViewingIcon from '../../../../icons/viewing.svg'

export const QA_NAME_APPLICANT_PROFILE_VIEWINGS = 'applicantProfileViewings'

export const QA_NAME_APPLICANT_PROFILE_VIEWINGS_BOOK =
  'applicantProfileViewingsBook'

export const QA_NAME_APPLICANT_PROFILE_VIEWINGS_RETRY =
  'applicantProfileViewingsRetry'

export const QA_NAME_APPLICANT_PROFILE_VIEWINGS_TABLE = 'applicantViewingsTable'

export const APPLICANT_PROFILE_VIEWINGS_BOOK_ACTION = {
  Icon: ViewingIcon,
  qaName: QA_NAME_APPLICANT_PROFILE_VIEWINGS_BOOK,
  textKey: 'RentalPortal.ListingProfileFooterBookViewingBtnKey',
  tooltipKey:
    'RentalPortal.ListingProfileFooterBookViewingUnavailableTooltipKey',
}

export const APPLICANT_PROFILE_VIEWINGS_SKELETON_ROWS = 3

export const APPLICANT_VIEWINGS_PAGE_SIZE = 20

export const ApplicantViewingColumnName = {
  DateTime: 'start',
  Listing: 'listing_label',
  Status: 'status',
}

export const APPLICANT_VIEWING_COLUMNS_CONFIG = {
  [ApplicantViewingColumnName.DateTime]: {
    index: 0,
    name: ApplicantViewingColumnName.DateTime,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileViewingsDateTimeColumnKey',
    visible: true,
    width: 292,
  },
  [ApplicantViewingColumnName.Listing]: {
    index: 1,
    name: ApplicantViewingColumnName.Listing,
    ordering_field: null,
    title: 'RentalPortal.ApplicantListingColumnKey',
    visible: true,
  },
  [ApplicantViewingColumnName.Status]: {
    index: 2,
    name: ApplicantViewingColumnName.Status,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileViewingsStatusColumnKey',
    visible: true,
    width: 180,
  },
}
